import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=5d68a5c4&"
import script from "./instruction.vue?vue&type=script&lang=js&"
export * from "./instruction.vue?vue&type=script&lang=js&"
import style0 from "./instruction.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports